import { render } from "./DiaogTwoOptions.vue?vue&type=template&id=db493218&scoped=true"
import script from "./DiaogTwoOptions.vue?vue&type=script&lang=js"
export * from "./DiaogTwoOptions.vue?vue&type=script&lang=js"

import "./DiaogTwoOptions.vue?vue&type=style&index=0&id=db493218&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db493218"]])

export default __exports__